module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.018fdbf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Settings/Users/avatar-placeholder.png
// module id = 712
// module chunks = 1